import React from 'react'
import page from 'hoc/page'
import { DI } from 'modules'
import Form from 'common/components/form/new-form'
import Component from 'components/component'
import Field from 'components/form/field'
import { TextInput } from 'components/form/text-input'
import PaymentBlock, {
  PaymentBlockFields,
} from 'pages/business/components/payment-block'
import RadioButton from 'components/form/radio'
import Select from 'components/form/select-input'
import { Helmet } from 'react-helmet'

import Panel from './panel'
import Fixed from './fixed'
import Sent from './sent'

import 'submodules/responsivestyles/src/less/buying.less'
import 'submodules/responsivestyles/src/less/payments.less'
import { Redirect } from 'react-router'
import * as routes from 'config/routes'

export class RequestPlan extends Component {
  get strings() {
    return this.props.common.strings
  }

  sizes = [
    {
      title: '1—9',
      value: 'to9',
    },
    {
      title: '10—49',
      value: 'from10to49',
    },
    {
      title: '50—249',
      value: 'from50to249',
    },
    {
      title: this.strings['page.request_enterprise.form.size.more_then'],
      value: 'from250',
    },
  ]

  state = {
    sent: false,
    fixed: false,
    form: {
      agreement_request: {
        company_size: this.sizes[0].value,
      },
    },
  }

  componentDidMount() {
    this.props.actions.user.getAgreementRequestData()
  }

  onChangeFixed = fixed => {
    this.setState({ fixed })
  }

  onValidateForm = () => {}

  onChange = (ev, form) => {
    this.setState({ form })
  }

  onSubmit = (ev, form) => {
    if (this.onValidateForm.panic()) {
      const action = this.props.user.isSignedIn
        ? this.props.actions.user.agreementRequestForUser
        : this.props.actions.user.agreementRequest

      let region

      if (this.props.match.params.name === 'request-region') {
        region = this.props.common.locale
      }

      action({
        agreement_request: form.agreement_request,
        region,
      }).then(resp => {
        this.setState({
          sent: true,
        })
      })
    }
  }

  renderCountrySelect = () => {
    const { agreement_request } = this.state.form
    const agreementRequestData = this.props.user.agreementRequestData.payload
    const countries = agreementRequestData.countries
    const name = this.props.match.params.name
    const countryRegion = countries.find(c => c.code === 'RU')
    const isRegion = name === 'region'

    if (isRegion) {
      return (
        <>
          <span className="choose-plan-plan__paying">
            {countryRegion && countryRegion.name}
          </span>
          <input
            type="hidden"
            name="agreement_request[country_id]"
            value={countryRegion ? countryRegion.id : 0}
          />
        </>
      )
    } else {
      return (
        <Select
          items={agreementRequestData.countries}
          onValidateForm={this.onValidateForm}
          name="agreement_request[country_id]"
          value={+agreement_request.country_id}
          headerModificator="sign-in"
          getTitle={item => item.name}
          getValue={item => item.id}
          placeholder={
            this.strings[
              'page.request_enterprise.form.not_selected.placeholder'
            ]
          }
          isInput={true}
        />
      )
    }
  }

  render() {
    const { locale } = this.props.common
    const { agreement_request } = this.state.form
    const agreementRequestData = this.props.user.agreementRequestData.payload
    const name = this.props.match.params.name === 'subscription' ? 'enterprise' : this.props.match.params.name;

    const title = (name => {
      switch (name) {
        case 'region':
          return this.strings['page.request_enterprise.title.region']
        case 'subscription':
          return this.strings['page.request_enterprise.title.enterprise']
        default:
          return this.strings['page.request_enterprise.title.enterprise']
      }
    })(name)

    if (this.state.sent) {
      return <Sent name={name} />
    }

    if(this.props.match.params.name === 'enterprise') {
      return <Redirect to={`${routes.notFound.getPath(locale)}`} />
    }

    return (
      <section className="content">
        <Helmet title={title + ` | ${this.strings['site.title']}`} />
        <div className="wrap wrap--high">
          <div className="buying buying--enterprise">
            <span className="buying__title">{title}</span>
            <section className="content-inner content-inner--buying content-inner--enterprise">
              <Form
                onChange={this.onChange}
                onSubmit={this.onSubmit}
                ref={cmp => (this.form = cmp)}
              >
                <input
                  type="hidden"
                  name="agreement_request[agreement_type]"
                  value={name}
                />
                <PaymentBlock
                  title={
                    this.strings['page.request_enterprise.form.title_personal']
                  }
                  enterprise
                >
                  <PaymentBlockFields>
                    <Field
                      label={
                        this.strings['page.request_enterprise.form.first_name']
                      }
                      className="field"
                    >
                      <TextInput
                        isRequired
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[first_name]"
                        value={agreement_request.first_name}
                        isLatin
                      />
                    </Field>
                    <Field
                      label={
                        this.strings['page.request_enterprise.form.last_name']
                      }
                      className="field"
                    >
                      <TextInput
                        isRequired
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[last_name]"
                        value={agreement_request.last_name}
                        isLatin
                      />
                    </Field>
                    <Field
                      label={
                        this.strings[
                          'page.request_enterprise.form.phone_number'
                        ]
                      }
                      className="field"
                    >
                      <TextInput
                        isRequired
                        isPhone
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[phone_number]"
                        value={agreement_request.phone_number}
                        tabletWidth="150"
                        placeholder="+"
                      />
                    </Field>
                    <Field
                      label={
                        this.strings[
                          'page.request_enterprise.form.business_email'
                        ]
                      }
                      className="field"
                    >
                      <TextInput
                        isRequired
                        isEmail
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[business_email]"
                        value={agreement_request.business_email}
                      />
                    </Field>
                    <Field
                      label={
                        this.strings['page.request_enterprise.form.job_title']
                      }
                      className="field"
                    >
                      <Select
                        items={agreementRequestData.job_titles}
                        isRequired
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[job_title_id]"
                        value={+agreement_request.job_title_id}
                        headerModificator="sign-in"
                        getTitle={item => item.name}
                        getValue={item => item.id}
                        placeholder={
                          this.strings[
                            'page.request_enterprise.form.job_title.placeholder'
                          ]
                        }
                        isInput={true}
                      />
                    </Field>
                  </PaymentBlockFields>
                </PaymentBlock>
                <PaymentBlock
                  title={
                    this.strings['page.request_enterprise.form.title_about']
                  }
                  enterprise
                >
                  <PaymentBlockFields>
                    <Field
                      label={
                        this.strings[
                          'page.request_enterprise.form.company_name'
                        ]
                      }
                      className="field"
                    >
                      <TextInput
                        isRequired
                        isLatin
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[company_name]"
                        value={agreement_request.company_name}
                      />
                    </Field>
                    <Field
                      label={
                        this.strings[
                          'page.request_enterprise.form.company_type_id'
                        ]
                      }
                      className="field"
                    >
                      <Select
                        items={agreementRequestData.company_types.concat({
                          id: '-1',
                          name: this.strings[
                            'page.request_enterprise.form.company.other'
                          ],
                        })}
                        isRequired
                        onValidateForm={this.onValidateForm}
                        name="agreement_request[company_type_id]"
                        value={+agreement_request.company_type_id}
                        headerModificator="sign-in"
                        getTitle={item => item.name}
                        getValue={item => item.id}
                        placeholder={
                          this.strings[
                            'page.request_enterprise.form.type.placeholder'
                          ]
                        }
                        isInput={true}
                      />
                      {agreement_request.company_type_id === '-1' && (
                        <TextInput
                          isRequired
                          isLatin
                          onValidateForm={this.onValidateForm}
                          name="agreement_request[custom_company_type]"
                          value={agreement_request.custom_company_type}
                          placeholder={
                            this.strings[
                              'page.request_enterprise.form.type.placeholder'
                            ]
                          }
                        />
                      )}
                    </Field>
                    <Field
                      label={
                        this.strings[
                          'page.request_enterprise.form.company_size'
                        ]
                      }
                      className="field"
                      labelNotPadded
                    >
                      <div className="buying__billing-type">
                        <span className="buying__billing-type-help">
                          {
                            this.strings[
                              'page.request_enterprise.form.size.subtitle'
                            ]
                          }
                        </span>
                        {this.sizes.map(item => (
                          <RadioButton
                            key={item.value}
                            name="agreement_request[company_size]"
                            value={item.value}
                            checked={
                              agreement_request.company_size === item.value
                            }
                          >
                            {item.title}
                          </RadioButton>
                        ))}
                      </div>
                    </Field>
                    <Field
                      label={
                        this.strings['page.request_enterprise.form.country_id']
                      }
                      className="field"
                    >
                      {this.renderCountrySelect()}
                    </Field>
                  </PaymentBlockFields>
                </PaymentBlock>
                <PaymentBlock left={false} right={false}>
                  <Panel
                    isFormFilled={false}
                    onChangeFixed={this.onChangeFixed}
                  />
                  <Fixed visible={this.state.fixed}>
                    <Panel onClickSubmit={() => this.form.submit()} />
                  </Fixed>
                </PaymentBlock>
              </Form>
            </section>
          </div>
        </div>
      </section>
    )
  }
}

export default page(DI(['user', 'common'])(RequestPlan), {
  clear: true,
})
